import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ContractPaymentData {
  contractId: string;
  amount: number;
  currency: string;
  professionalName: string;
  clientName: string;
  chatId?: string;
}

interface NotificationState {
  contractPaymentNotification: {
    visible: boolean;
    data: ContractPaymentData | null;
  };
}

const initialState: NotificationState = {
  contractPaymentNotification: {
    visible: false,
    data: null,
  },
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showContractPaymentNotification: (state, action: PayloadAction<ContractPaymentData>) => {
      console.log("showContractPaymentNotification action dispatched:", action.payload);
      state.contractPaymentNotification = {
        visible: true,
        data: action.payload,
      };
      console.log("Notification state updated:", state.contractPaymentNotification);
    },
    hideContractPaymentNotification: (state) => {
      console.log("hideContractPaymentNotification action dispatched");
      state.contractPaymentNotification = {
        visible: false,
        data: null,
      };
      console.log("Notification state reset:", state.contractPaymentNotification);
    },
  },
});

export const {
  showContractPaymentNotification,
  hideContractPaymentNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
